import MeasuredDeviationsMosaic from './MeasuredDeviationsMosaic';
export default MeasuredDeviationsMosaic;
